export default __webpack_public_path__ + "images/ME.0ac8e20.png";